export const DEMO_INVOICE_FAKE_SEND_DELAY = 1000
